export default __webpack_public_path__ + "static/media/codestates.1a78b0ee.png";